import { ToothEndodontic } from '../../../../graphql/graphql';

export interface EndodonticButtonOption {
	label: string;
	value: keyof ToothEndodontic;
}

export const ENDODONTIC_BUTTON_OPTIONS: EndodonticButtonOption[] = [
	{
		label: 'patientTreatment.meddiDENT.dentalCross.endodontic.cold',
		value: 'cold',
	},
	{
		label: 'patientTreatment.meddiDENT.dentalCross.endodontic.percussion',
		value: 'percussion',
	},
	{
		label: 'patientTreatment.meddiDENT.dentalCross.endodontic.palpation',
		value: 'palpation',
	},
	{
		label: 'patientTreatment.meddiDENT.dentalCross.endodontic.heat',
		value: 'heat',
	},
	{
		label: 'patientTreatment.meddiDENT.dentalCross.endodontic.electric',
		value: 'electric',
	},
];
